<template>
  <div id="dropdown-card">
    <v-select
      v-if="filterType === `program`"
      v-model="selectedProgramLocal"
      :items="programs"
      return-object
      item-text="name"
      label="Program"
      @change="clearAndUpdate(`program`, selectedProgramLocal)"
    />

    <v-select
      v-if="filterType === `project`"
      v-model="selectedProjectLocal"
      :items="filteredProjects"
      no-data-text="You must first choose a Program"
      return-object
      item-text="name"
      label="Project"
      @change="clearAndUpdate(`project`, selectedProjectLocal)"
    />

    <v-select
      v-if="filterType === `survey`"
      v-model="selectedSurveyLocal"
      :items="filteredSurveys"
      no-data-text="You must first choose a Project"
      return-object
      item-text="name"
      label="Survey"
      @change="clearAndUpdate(`survey`, selectedSurveyLocal)"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FilterByDropdown",
  props: {
    filterType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedProgramLocal: {},
      selectedProjectLocal: {},
      selectedSurveyLocal: {}
    };
  },
  computed: {
    ...mapState({
      programs: state => state.programs.programs,
      selectedProgram: state => state.programs.selectedProgram,
      projects: state => state.projects.projects,
      filteredProjects: state => state.projects.filteredProjects,
      selectedProject: state => state.projects.selectedProject,
      surveys: state => state.survey.surveys,
      filteredSurveys: state => state.survey.filteredSurveys
    })
  },
  watch: {
    selectedProgramLocal() {
      this.filterProjects(
        this.projects.filter(
          project => project.program === this.selectedProgramLocal.pk
        )
      );
    },
    selectedProjectLocal() {
      this.filterSurveys(
        this.surveys.filter(
          survey => survey.project === this.selectedProjectLocal.pk
        )
      );
    },
    selectedProgram(){
      this.clearProject();
      this.clearSurvey();
    },
    selectedProject(){
      this.clearSurvey();
    }
  },
  methods: {
    ...mapActions({
      updateSelectedProgram: "programs/updateSelectedProgram",
      updateSelectedProject: "projects/updateSelectedProject",
      filterProjects: "projects/filterProjects",
      updateSelectedSurvey: "survey/updateSelectedSurvey",
      updateSelectedSurveyNumber: "survey/updateSelectedSurveyNumber",
      filterSurveys: "survey/filterSurveys"
    }),
    clearAndUpdate(filter, selection) {
      switch (filter) {
      case `program`:
        this.clearProject();
        this.clearSurvey();
        this.updateSelectedProgram(selection);
        break;
      case `project`:
        this.clearSurvey();
        this.updateSelectedProject(selection);
        break;
      case `survey`:
        this.updateSelectedSurvey(selection);
        break;
      }
    },
    clearProgram() {
      this.selectedProgramLocal = {};
      this.updateSelectedProgram(null);
    },
    clearProject() {
      this.selectedProjectLocal = {};
      this.updateSelectedProject({});
    },
    clearSurvey() {
      this.selectedSurveyLocal = {};
      this.updateSelectedSurvey({});
      this.updateSelectedSurveyNumber(-1);
    },
    clearFilters() {
      this.clearProgram();
      (this.selectedProgramLocal = {}), (this.selectedProjectLocal = {});
      this.selectedSurveyLocal = {};
    }
  }
};
</script>
